import { easeBackInOut } from "d3";
import { BitmapLayer } from "@deck.gl/layers";
import React, { useState, useEffect } from "react";


export const createImageLayer = (currentSlide) => {


  function adjustBoundsForImageAspect(bounds, imageWidth, imageHeight) {
    const [westBound, southBound, eastBound, northBound] = bounds;
  
    const imageAspectRatio = imageWidth / imageHeight;
  
    const longitudeSpan = eastBound - westBound;
  
    const latitudeSpan = longitudeSpan / imageAspectRatio;
  
    const latitudeMid = (southBound + northBound) / 2;
    const newSouthBound = latitudeMid - (latitudeSpan / 2);
    const newNorthBound = latitudeMid + (latitudeSpan / 2);
  
    return [westBound, newSouthBound, eastBound, newNorthBound];
    }
    

    const originalBounds = [32.513968, 45.345968, 32.540068, 45.34854];
    const imageWidth = 5000;  // Replace this with your image's width in pixels
    const imageHeight = 3000; // Replace this with your image's height in pixels

    const adjustedBounds = adjustBoundsForImageAspect(originalBounds, imageWidth, imageHeight);


  const imageData = new BitmapLayer({
    id: 'image-layer',
    data: null,
    image: "assets/Crimea_Maxar.jpg",
    bounds: adjustedBounds,


  });

  return imageData;
};
